<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="saveButtonAction" title="Save Confirmation - User Profile">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-full-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-full-name">
						{{ model != null ? model.fullName : "" }}
					</b-form-group>
					<b-form-group id="fieldset-job-description" label-cols-sm="4" label-cols-lg="3" label="Job" label-for="filter-job-description">
						{{ model != null ? model.jobDescription : "" }}
					</b-form-group>
					<b-form-group id="fieldset-email" label-cols-sm="4" label-cols-lg="3" label="Email" label-for="filter-email">
						{{ model != null ? model.email : "" }}
					</b-form-group>
					<b-form-group id="fieldset-core-user" label-cols-sm="4" label-cols-lg="3" label="Core User" label-for="filter-core-user">
						{{ model != null ? ( model.coreUser != null ? model.coreUser.firstName : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-branch" label-cols-sm="4" label-cols-lg="3" label="Kantor" label-for="filter-branch">
						{{ model != null ? ( model.branch != null ? model.branch.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-directorate" label-cols-sm="4" label-cols-lg="3" label="Direktorat" label-for="filter-directorate">
						{{ model != null ? ( model.directorate != null ? model.directorate.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-employee-level" label-cols-sm="4" label-cols-lg="3" label="Employee Level" label-for="filter-employee-level">
						{{ model != null ? ( model.employeeLevel != null ? model.employeeLevel.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-employee-status" label-cols-sm="4" label-cols-lg="3" label="Employee Status" label-for="filter-employee-status">
						{{ model != null ? ( model.employeeStatus != null ? model.employeeStatus.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-education-level" label-cols-sm="4" label-cols-lg="3" label="Education Level" label-for="filter-education-level">
						{{ model != null ? ( model.educationLevel != null ? model.educationLevel.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-blood-type" label-cols-sm="4" label-cols-lg="3" label="Blood Type" label-for="filter-blood-type">
						{{ model != null ? ( model.bloodType != null ? model.bloodType.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-marital-status" label-cols-sm="4" label-cols-lg="3" label="Marital Status" label-for="filter-marital-status">
						{{ model != null ? ( model.maritalStatus != null ? model.maritalStatus.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-join-date" label-cols-sm="4" label-cols-lg="3" label="Join Date" label-for="filter-join-date">
						{{ (model != null ? model.joinDate : "") | moment("DD-MMM-YYYY") }}
					</b-form-group>
					<b-form-group id="fieldset-birth-date" label-cols-sm="4" label-cols-lg="3" label="Birth Date" label-for="filter-birth-date">
						{{ (model != null ? model.birthDate : "") | moment("DD-MMM-YYYY") }}
					</b-form-group>
					<b-form-group id="fieldset-kids-count" label-cols-sm="4" label-cols-lg="3" label="Kids Count" label-for="filter-kids-count">
						{{ model != null ? model.kidsCount : "" }}
					</b-form-group>
					<b-form-group id="fieldset-address" label-cols-sm="4" label-cols-lg="3" label="Address" label-for="filter-address">
						{{ model != null ? model.address : "" }}
					</b-form-group>
					<b-form-group id="fieldset-phone-number" label-cols-sm="4" label-cols-lg="3" label="Phone Number" label-for="filter-phone-number">
						{{ model != null ? model.phoneNumber : "" }}
					</b-form-group>
					<b-form-group id="fieldset-npwp-number" label-cols-sm="4" label-cols-lg="3" label="Npwp Number" label-for="filter-npwp-number">
						{{ model != null ? model.npwpNumber : "" }}
					</b-form-group>
					<b-form-group id="fieldset-nip" label-cols-sm="4" label-cols-lg="3" label="Nip" label-for="filter-nip">
						{{ model != null ? model.nip : "" }}
					</b-form-group>
					<b-form-group id="fieldset-real-email" label-cols-sm="4" label-cols-lg="3" label="Real Email" label-for="filter-real-email">
						{{ model != null ? model.realEmail : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import UserProfile from '@/models/UserProfile/UserProfile';
import UserProfileList from '@/models/UserProfile/UserProfileList';
import UserProfileFilter from '@/filters/UserProfile/UserProfileFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	/*APP_DETAIL_PROP_DEFINITION*/
	props : ["openPopup", "model", "saveActionMethod", "resetMethod"],
	/*END_APP_DETAIL_PROP_DEFINITION*/
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterUserProfile : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentUserProfilePage : 1,
			userProfilePageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByUserProfile: '',
			sortDescUserProfile: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETUserProfile*/
		getUserProfile : async function(id) {
			this.isBusy = true;
			UserProfile.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETUserProfile*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'userprofilecopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_SAVEBUTTONACTION*/
		saveButtonAction(modalEvent) {
			this.$emit("saveActionMethod", modalEvent);
		},
		/*END_APP_DETAIL_SAVEBUTTONACTION*/
		/*APP_DETAIL_RESETMODAL*/
		resetModal() {
			this.$emit('resetMethod'); 
		},
		/*END_APP_DETAIL_RESETMODAL*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterUserProfile = new UserProfileFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
		isShowPopup: {
			get: function(){
				if (this.openPopup) return true; 
				else return false; 
			},
			set: function(newValue){ }
		},
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
